module.exports = __webpack_public_path__ + "static/media/soul_tip_preview.b997d2b5.gif";